import { __awaiter, __generator } from "tslib";
import { handleDirectPurchase } from './handleDirectPurchase';
import { PageMap } from '@wix/wixstores-client-core';
import { getCheckoutEligibility, handleCheckoutEligibility } from './checkoutEligibility';
import { getCheckoutUrl } from './getCheckoutUrl';
export var createCheckoutExports = function (_a) {
    var context = _a.context, legacyOrigin = _a.origin;
    return ({
        handleDirectPurchase: handleDirectPurchase({ context: context, origin: legacyOrigin }),
        getCheckoutUrl: getCheckoutUrl({ context: context }),
        getEligibility: getCheckoutEligibility({ context: context }),
        handleEligibility: handleCheckoutEligibility({ context: context }),
        preloadCheckoutPage: function () { return __awaiter(void 0, void 0, void 0, function () {
            var sectionUrl, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, context.siteStore.getSectionUrl(PageMap.CHECKOUT)];
                    case 1:
                        sectionUrl = _a.sent();
                        if (sectionUrl.relativeUrl) {
                            context.siteStore.siteApis.prefetchPageResources({ pages: [sectionUrl.relativeUrl] });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('failed to prefetch checkout page', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
};
//# sourceMappingURL=wixcode.checkout.js.map